<script setup>
import { onMounted, ref } from 'vue';
import card_header from '@/components/card_header.vue';
import { useRoute } from 'vue-router';
import { create_ticket } from '@/services/tickets';
import { swalError, swalSuccess } from '@/helper';
import { get_option } from '@/services/packages';

const questionaire = ref([])

const form = ref({})
const route = useRoute()
const isLoading = ref(true)
onMounted(async()=>{
  let user_data = JSON.parse(localStorage.getItem('user_data'))
  form.value.user_name = user_data.first_name + ' ' + user_data.last_name
  await get_feedback_question()
  isLoading.value = false
})

async function get_feedback_question(){
  let response = await get_option('system_feedback_question')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result){
    questionaire.value = parseQuestion(response.result)
  }
}

function parseQuestion(result){
  let temp = result.included.map(item => {
    return {
      id: item.id,
      title: item.attributes.key,
      type: item.attributes.value,
    }
  })
  return temp
}

const isSubmit = ref(false)
async function submitForm(){
  isSubmit.value = true
  const formData = new FormData(feedback_form);
  const formObj = []

  for (const [key, value] of formData) {
    let {title} = questionaire.value.find(item => item.id == key)
    formObj.push({title, answer: value})
  }

  let params = {}
  params.ticket_type = 'system_feedback'
  params.topic = 'Feedback in ' + form.value.user_name
  let userData = JSON.parse(localStorage.getItem('user_data'))
  let user_name = capitalizeWords(`${userData.first_name} ${userData.last_name}`)
  params.subject = user_name + ' has submit feedback'
  params.meta = JSON.stringify(formObj)
  let response = await create_ticket(params)
  if(response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Form has been submitted')
  document.getElementById('feedback_form').reset()
  isSubmit.value = false
}

function capitalizeWords(str) {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="System Feedback Form"/>
    <div class="card">
      <card_header title="System Feedback Form"/>
      <div class="card-body">
        <form @submit.prevent="submitForm" id="feedback_form">
          <div class="row mb-3">
            <div v-for="question in questionaire" :key="question.id" class="col-12 mb-3">
              <label class="form-label">
                {{ question.title }}
              </label>

              <template v-if="question.type == 'choice'">
                <div class="d-flex">
                  <label class="d-flex align-items-center me-2">
                    <input type="radio" :name="question.id" value="yes" required>
                    <span class="ms-1 my-auto">Yes</span>
                  </label>
                  <label class="d-flex align-items-center me-2">
                    <input type="radio" :name="question.id" value="no"  required>
                    <span class="ms-1 my-auto">No</span>
                  </label>
                </div>
              </template>
              <template v-if="question.type == 'input'">
                <div class="col">
                  <input class="form-control" type="text"
                    placeholder="Text input"
                    required
                    value=""
                    :name="question.id"
                  >
                </div>
              </template>
            </div>
          </div>

          <div>
            <button type="submit" class="btn btn-light-success">
              <span v-if="!isSubmit">Submit</span>
              <span v-else>
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>